import { useProductsManagementUpload } from '@/activityLog/productsManagement/Inventory/hooks/useProductsManagementUpload.ts';
import { UploadButton } from '@/activityLog/common/Upload/UploadButton.tsx';

export const ProductsManagementUploadButton = () => {
  const { selectedFile, selectFile, uploadFile, importError, setImportError, isPending } =
    useProductsManagementUpload();

  return (
    <UploadButton
      importError={importError}
      isPending={isPending}
      selectedFile={selectedFile}
      inputId={'productsManagementUpload'}
      onSelectFile={selectFile}
      onConfirm={() => {
        uploadFile();
      }}
      onCancel={() => {
        selectFile(null);
      }}
      onCloseSnackbar={function (): void {
        setImportError(null);
        selectFile(null);
      }}
    />
  );
};
